import React, { useEffect, useState } from "react";
import UseGame from "../stores/UseGame";
import arrowRight from "/images/right-arrow.png";
import close from "/images/close.png";
import { stories } from "../data/Stories";

export default function Interface() {
  const [phraseIndex, setPhraseIndex] = useState(0);
  const [currentPhrase, setCurrentPhrase] = useState(null);

  const help = UseGame((state) => state.help);
  const setHelp = UseGame((state) => state.setHelp);

  //#region GLOBAL STATES
  const clickables = UseGame((state) => state.clickables);
  const index = UseGame((state) => state.index);
  const restart = UseGame((state) => state.restart);
  const setIndex = UseGame((state) => state.setIndex);
  const phase = UseGame((state) => state.phase);
  const clicked = UseGame((state) => state.clicked);
  const focus = UseGame((state) => state.focus);
  const setObject = UseGame((state) => state.setObject);
  const story = UseGame((state) => state.story);
  //#endregion GLOBAL STATES

  //#region FUNCTIONS
  const setPrevious = () => {
    let i;
    if (index - 1 !== -1) {
      i = index - 1;
    } else {
      i = clickables.length - 1;
    }
    handleArrowClick(i);
  };
  const setNext = () => {
    let i;
    if (index + 1 === clickables.length) {
      i = 0;
    } else {
      i = index + 1;
    }
    handleArrowClick(i);
  };

  const handleArrowClick = (i) => {
    setIndex(i);
    setObject(clickables[i]);
    setPhraseIndex(0);
    story();
  };

  const setClose = () => {
    restart();
    setPhraseIndex(0);
  };

  const nextPhrase = () => {
    setPhraseIndex(phraseIndex + 1);
    if (clicked && stories[clicked]) {
      if (phraseIndex + 1 > stories[clicked].length - 1) {
        setPhraseIndex(0);
        focus();
      }
    }
  };
  //#endregion FUNCTIONS

  useEffect(() => {
    if (clicked && stories[clicked]) {
      if (phraseIndex <= stories[clicked].length - 1) {
        setCurrentPhrase(stories[clicked][phraseIndex]);
      }
    }
  }, [clicked, phraseIndex]);

  //#region KEY EVENTS
  const keys = ["Enter", "Space"];
  window.addEventListener(
    "keyup",
    function (e) {
      if (keys.includes(e.code)) {
        nextPhrase();
      } else if (e.code === "ArrowRight") {
        setNext();
      } else if (e.code === "ArrowLeft") {
        setPrevious();
      }
    },
    { once: true }
  );

  //#endregion KEY EVENTS

  return phase !== "ready" ? (
    <div className="interface">
      {phase !== "story" ? (
        <div className="div-arrows">
          <div className="arrow left" onClick={setPrevious}>
            <img src={arrowRight}></img>
          </div>
          <div className="arrow right" onClick={setNext}>
            <img src={arrowRight}></img>
          </div>
        </div>
      ) : (
        <div className="story" onClick={nextPhrase}>
          {currentPhrase}
          <p className="story-instruction">press enter</p>
        </div>
      )}
      <div className="close" onClick={setClose}>
        <img src={close}></img>
      </div>
    </div>
  ) : (
    <div className="interface">
      <div className="title">
        <h1>Viktor Van Hulle</h1>
        <h2> Game-, web- and mobile developer</h2>
      </div>
      <div className="subtext">
        <p>Drag and zoom to view</p>
      </div>
      <button
        className={!help ? "help-button guide-on" : "help-button"}
        onClick={() => setHelp(!help)}
      >
        ?
      </button>
    </div>
  );
}
